import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../../api"

export default function PopularGames() {

    const [playedGames, setPlayedGames] = useState([]);

  // fetch latest played games
useEffect(() => {
    api.get("user/games/played/")  // <-- Important: correct endpoint
      .then((res) => {
        setPlayedGames(res.data);  // <-- You need to create setPlayedGames state
      })
      .catch((err) => {
        console.error("Error loading played games:", err);
      });
  }, []);

    return (
        <div className="contentCol">
            {playedGames.length > 0 && (
                <>
                    <h2 className="alignRight">populære spil</h2>
                    <div className="gamesWindow">
                            {/* Ligningsmesteren */}
                            <div className="gameCard">
                                <h3>ligningsmesteren</h3>
                                <img
                                    src={`/images/ligningsmester.png`}
                                    alt="ligningsmesteren"
                                    className="h-32 w-32 rounded-lg mb-4"
                                />
                                <p className="text-sm">
                                    Det originale ligningspil. I tre niveauer.
                                </p>
                                <div className="flex justify-end mt-4">
                                    <Link to={`/Drills/ligningsmester`}>
                                    <button className="mt-4 px-4 py-2 bg-blue-500 font-nunito text-white rounded-lg">
                                        åben
                                    </button>
                                    </Link>
                                </div>
                            </div>
                            {/* Formelknuseren */}
                            <div className="gameCard">
                                <h3>formelknuseren</h3>
                                <img
                                    src={`/images/formelknuseren.png`}
                                    alt="formelknuseren"
                                    className="h-32 w-32 rounded-lg mb-4"
                                />
                                <p className="text-sm">
                                    Kommende spil om at bruge formler.
                                </p>
                                <div className="flex justify-end mt-4">
                                    <Link to={`/Drills/formelknuseren`}>
                                    <button className="mt-4 px-4 py-2 bg-blue-500 font-nunito text-white rounded-lg">
                                        åben
                                    </button>
                                    </Link>
                                </div>
                                {/* overlay */}
                                <div className="flex absolute inset-0 bg-gray-100 opacity-60 rounded-3xl justify-center items-center text-2xl text-rose-500 font-bold">
                                    <span className="rotate-45">kommer snart</span>
                                </div>
                            </div>
                            {/* Trigonometeren */}
                            <div className="gameCard">
                                <h3>trigonometeren</h3>
                                <img
                                    src={`/images/trigonometeren.png`}
                                    alt="formelknuseren"
                                    className="h-32 w-32 rounded-lg mb-4"
                                />
                                <p className="text-sm">
                                    Kommende spil om trekanter.
                                </p>
                                <div className="flex justify-end mt-4">
                                    <Link to={`/Drills/trigonometeren`}>
                                    <button className="mt-4 px-4 py-2 bg-blue-500 font-nunito text-white rounded-lg">
                                        åben
                                    </button>
                                    </Link>
                                </div>
                                {/* overlay */}
                                <div className="flex absolute inset-0 bg-gray-100 opacity-60 rounded-3xl justify-center items-center text-2xl text-rose-500 font-bold">
                                    <span className="rotate-45">kommer snart</span>
                                </div>
                            </div>
                    </div>
                </>
            )}
        </div>
    )
}